import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import SelectDateCore from "./SelectDateCore.jsx";
import CoreController from "./CoreController.jsx";
import { useTranslation } from '../../../../language';

export default function BloodCoreWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_bloodmarker')}
      specify={t('page_sp_core_health')}

      >

      {/* Main Page Content */}

       <CoreController />


    </PageProtectedLayout>

  );
}
